import invoke from "../calllambda"
import {seisleveljp} from "./seislevel"


const colors_blue = ["#6E6E6E", "#ACB9CA", "#B4C6E7", "#8EA9DB", "#4472C4", "#203764"]
const colors_ryg = ["#6E6E6E", "#B9E3B6", "#DCE3AC", "#FEE3A1", "#FCD5A4", "#FAC6A6"]
const marker_blue = ["lv0", "lv1", "lv2", "lv3", "lv4", "lv5"]
const marker_ryg = ["rlv0", "rlv1", "rlv2", "rlv3", "rlv4", "rlv5"]

export const kinds = [
    { name: "気温", unit: "℃", level:[25,30,35,40],colors: colors_blue, marker: marker_blue},
    { name: "湿度", unit: "%", level:[40,50,60,70],colors:colors_blue, marker: marker_blue},
    { name: "風速", unit: "m/s", level:[10,15,20,30],colors:colors_blue, marker: marker_blue},
    { name: "雨量", unit: "mm/h", level:[10,20,30,50],colors:colors_blue, marker: marker_blue},
    { name: "雷", unit: "", max: 100, level:[20,40,60,80],colors:colors_blue, marker: marker_blue},
    { name: "震度", unit: "", max: 5.5, level:[2.5,4.5,5.5,6.5],colors:colors_ryg, marker: marker_ryg},
];

export default async function sensorstatus(sites) {
    var points = [];
    if (sites.length < 1) return points;
    var sensors = [];
    for (var site of sites) {
        if ("sensors" in site) {
            if ("weather" in site.sensors)
                sensors = Array.from(new Set([...sensors, ...site.sensors.weather.map(function(val) {return val.id;})]));
            if ("earthquake" in site.sensors)
                sensors = Array.from(new Set([...sensors, ...site.sensors.earthquake.map(function(val) {return val.id;})]));
            if ("camera" in site.sensors)
                sensors = Array.from(new Set([...sensors, ...site.sensors.camera.map(function(val) {return val.id;})]));
        }
    }
    var value = await invoke("arn:aws:lambda:ap-northeast-1:068557983663:function:sensorstatus", { sensor_ids: sensors });

    for (var site of sites) {
        var temp=null, humi=null, wind=null, rain=null, thunder=null,seis=null,camcode=null;
        if ("sensors" in site) {
            if ("weather" in site.sensors && site.sensors.weather.length > 0) {
                var res = value.find(p => site.sensors.weather[0].id === p.sensor_id);
                if (res != null && new Date() - Date.parse(res["datetime"]) < 30 * 60 * 1000) {//30分以内にない場合は欠測
                    temp = res.temp; humi= res.humi; wind = res.wind_spd; rain = res.rain_h; thunder = res.ligh_str;
                }
            }
            if ("earthquake" in site.sensors && site.sensors.earthquake.length > 0) {
                var res = value.find(p => site.sensors.earthquake[0].id === p.sensor_id);
                if (res != null && "events" in res ) {
                    seis = 0;
                    for ( var event of res.events ) {
                        if ( new Date() - Date.parse(event["datetime"]) < 60 * 60 * 1000 * 24) {//24時間以内の最大の地震を表示する
                            seis = Math.max(seis,event["seis"]);
                        }
                    }                    
                }
            }
            if ("camera" in site.sensors && site.sensors.camera.length > 0) {
                var res = value.find(p => site.sensors.camera[0].id === p.sensor_id);
                if (res != null ) { camcode = res.url };
            }
        }
        points.push({ ...site, temp: { value: temp }, wind: { value: wind }, humi: { value: humi }, rain: { value: rain }, thunder: { value: thunder }, seis: { value: seis }, camcode: { value: camcode} });
    }
    for (var p of points) {
        //色設定
        p.temp.color = valueColor(kinds.find(kind => kind.name === "気温"), p.temp.value);
        p.humi.color = valueColor(kinds.find(kind => kind.name === "湿度"), p.humi.value);
        p.wind.color = valueColor(kinds.find(kind => kind.name === "風速"), p.wind.value);
        p.rain.color = valueColor(kinds.find(kind => kind.name === "雨量"), p.rain.value);
        p.thunder.color = valueColor(kinds.find(kind => kind.name === "雷"), p.thunder.value);
        p.seis.color = valueColor(kinds.find(kind => kind.name === "震度"), p.seis.value);
        //文字色設定
        p.temp.fontcolor = (p.temp.color == colors_blue[5]) ? "#FFFFFF" : "#000000";
        p.humi.fontcolor = (p.humi.color == colors_blue[5]) ? "#FFFFFF" : "#000000";
        p.wind.fontcolor = (p.wind.color == colors_blue[5]) ? "#FFFFFF" : "#000000";
        p.rain.fontcolor = (p.rain.color == colors_blue[5]) ? "#FFFFFF" : "#000000";
        p.thunder.fontcolor = (p.thunder.color == colors_blue[5]) ? "#FFFFFF" : "#000000";
        p.seis.fontcolor = "#000000";        
        //マーカー色設定
        p.temp.markerColor = markerColor(kinds.find(kind => kind.name === "気温"), p.temp.value);
        p.humi.markerColor = markerColor(kinds.find(kind => kind.name === "湿度"), p.humi.value);
        p.wind.markerColor = markerColor(kinds.find(kind => kind.name === "風速"), p.wind.value);
        p.rain.markerColor = markerColor(kinds.find(kind => kind.name === "雨量"), p.rain.value);
        p.thunder.markerColor = markerColor(kinds.find(kind => kind.name === "雷"), p.thunder.value);
        p.seis.markerColor = markerColor(kinds.find(kind => kind.name === "震度"), p.seis.value);
        //表示値
        p.temp.display = p.temp.value != null ? p.temp.value.toFixed(1) : "　";
        p.humi.display = p.humi.value != null ? p.humi.value.toFixed(1) : "　";
        p.wind.display = p.wind.value != null ? p.wind.value.toFixed(1) : "　";
        p.rain.display = p.rain.value != null ? p.rain.value.toFixed(1) : "　";
        p.thunder.display = p.rain.value != null ? p.rain.value.toFixed(0) : "　";
        p.seis.display = p.seis.value != null ? seisleveljp(p.seis.value.toFixed(0)) : "　";
        p.seis.display = p.seis.value == 0 ? "-" : p.seis.display;
        //初期値
        p.selected = p.temp;
    }
    function valueColor(kind, value) {
        if (value == null || (kind.name==="震度" && value==0)) return kind.colors[0];
        if (value >= kind.level[3]) return kind.colors[5];
        else if (value >= kind.level[2]) return kind.colors[4];
        else if (value >= kind.level[1]) return kind.colors[3];
        else if (value >= kind.level[0]) return kind.colors[2];
        else return kind.colors[1];
    }
    function markerColor(kind, value) {
        if (value == null || (kind.name==="震度" && value==0)) return kind.marker[0];
        if (value >= kind.level[3]) return kind.marker[5];
        else if (value >= kind.level[2]) return kind.marker[4];
        else if (value >= kind.level[1]) return kind.marker[3];
        else if (value >= kind.level[0]) return kind.marker[2];
        else return kind.marker[1];
    }
    return points;
}